import React from 'react'
import { Outlet } from 'react-router'
import Header from '../components/Header'
import Footer from '../components/Footer'

export const AppLayout = () => {
    return (
        <>
            <Header />
            <main style={{ paddingTop: '90px' }} className='container mx-auto'>
                <Outlet />
            </main>
            <Footer />
        </>
    )
}
